import { IGatsbyImageData } from "gatsby-plugin-image";
import {
  Infer,
  array,
  assign,
  enums,
  nullable,
  number,
  object,
  optional,
  string,
} from "superstruct";
import { icons } from "components/Icon/icons";
import { nullUndefined } from "utilities/validatoros/types";

export const ModLang = enums(["it", "en"]);

export const ModCfIconNames = enums([...Object.keys(icons)] as const);

export type CfIconNames = keyof typeof icons;

// todo can we remove this?
// export type CfIconNames = Infer<typeof ModCfIconNames>;

export const ModFile = object({
  url: string(),
});

export const ModCfGatbsyImageData = object({
  images: object({
    sources: optional(
      array(
        object({
          srcSet: string(),
          sizes: string(),
          type: string(),
        }),
      ),
    ),
    fallback: optional(
      object({
        src: string(),
        srcSet: string(),
        sizes: string(),
      }),
    ),
  }),
  layout: string(),
  backgroundColor: string(),
  width: number(),
  height: number(),
  placeholder: object({
    fallback: string(),
  }),
});

export const ModCfFile = object({
  file: ModFile,
});
export const ModCfFileImage = object({
  gatsbyImageData: nullable(ModCfGatbsyImageData),
  file: ModFile,
  description: nullable(string()),
});

export type CfFile = Infer<typeof ModCfFile>;

export type CfFileImage = Omit<
  Infer<typeof ModCfFileImage>,
  "gatsbyImageData"
> & {
  gatsbyImageData?: IGatsbyImageData;
};

export type CfFileSingleImage = Omit<
  Infer<typeof ModCfFileImage>,
  "gatsbyImageData"
> & {
  gatsbyImageData?: IGatsbyImageData;
  __typename: "ContentfulAsset";
  id: string;
  contentful_id: string;
};

export const ModCfAbstract = object({
  abstract: string(),
});

export type CfAbstract = Infer<typeof ModCfAbstract>;

export const ChildMarkdownRemark = object({
  html: string(),
});

export const ModCfText = object({
  text: string(),
  childMarkdownRemark: nullUndefined(ChildMarkdownRemark),
});

export const ModCfFileDetailed = object({
  file: assign(
    ModFile,
    object({
      contentType: nullable(string()),
      details: object({
        size: number(),
      }),
    }),
  ),
});

export type TypeNameDictionary =
  | "ContentfulAccordionV2"
  | "ContentfulAccordionItemV2"
  | "ContentfulBankSearchV2"
  | "ContentfulBannerAdvV2"
  | "ContentfulBannerDownloadApp"
  | "ContentfulBoxLaunchV2"
  | "ContentfulCard1V2"
  | "ContentfulCard2V2"
  | "ContentfulCard3V2"
  | "ContentfulCard4V2"
  | "ContentfulCard5V2"
  | "ContentfulCard6V2"
  | "ContentfulCard7V2"
  | "ContentfulCard8V2"
  | "ContentfulCard9"
  | "ContentfulCardOfferV2"
  | "ContentfulCardPromo"
  | "ContentfulCardCart"
  | "ContentfulCtaContentV2"
  | "ContentfulCtaListV2"
  | "ContentfulCtaReferenceV2"
  | "ContentfulCustomComponentV2"
  | "ContentfulCustomHtmlV2"
  | "ContentfulFormDynamicFieldsV2"
  | "ContentfulFormCustomDynamicFields"
  | "ContentfulFormFieldV2"
  | "ContentfulDoubleContentV2"
  | "ContentfulDoubleContentBgBlockV2"
  | "ContentfulDoubleContentBlockV2"
  | "ContentfulDoubleContentSlideV2"
  | "ContentfulFaqListPreviewV2"
  | "ContentfulFileItemV2"
  | "ContentfulFileListV2"
  | "ContentfulFilterListV2"
  | "ContentfulHeroContentBlockStickyV2"
  | "ContentfulHeroContentV2"
  | "ContentfulHeroImageV2"
  | "ContentfulIconV2"
  | "ContentfulImageV2"
  | "ContentfulInDepthImageTextV2"
  | "ContentfulListV2"
  | "ContentfulModalV2"
  | "ContentfulMapTlpServicesV2"
  | "ContentfulMapTlpServicesLocatorV2"
  | "ContentfulSectionScrollV2"
  | "ContentfulSectionScrollItemV2"
  | "ContentfulSliderV2"
  | "ContentfulSliderSlideV2"
  | "ContentfulStripV2"
  | "ContentfulTextV2"
  | "ContentfulVideoV2"
  | "ContentfulSeparatorV2"
  | "ContentfulTabV2"
  | "ContentfulTabStripV2"
  | "ContentfulSmsV2"
  | "ContentfulMapFilter"
  | "ContentfulBannerWrapV2"
  | "ContentfulHorizontalCarousel"
  | "ContentfulEditorial"
  | "ContentfulCardIcon"
  | "ContentfulCardGeneric"
  | "ContentfulCardBackgroundImage"
  | "ContentfulGridRow"
  | "ContentfulTag"
  | "ContentfulTagGroup"
  | "ContentfulOpenBanner"
  | "ContentfulMinimalStripContent"
  | "ContentfulStickyDoubleColumn"
  | "ContentfulCardFullImage"
  | "ContentfulSliderCards"
  | "ContentfulHeroBlock"
  | "ContentfulHeroBanner"
  | "ContentfulServiceCard"
  | "ContentfulServicesGridFilter"
  | "ContentfulViewer3D"
  | "ContentfulServiceCategory";

export const ModCfProportionsValue = enums([
  "6:6",
  "5:7",
  "7:5",
  "4:8",
  "8:4",
  "3:9",
  "9:3",
  "2:10",
  "10:2",
  "1:11",
  "11:1",
]);
